import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import User from './views/User.vue'
import Provider from './views/Provider.vue'
import Test from './views/Test.vue'

Vue.use(Router)

const scrollToCategory = function ( aPath ){
  // Prüfen, ob die aktive Kategorie sichtbar ist
  let activeCat = document.querySelector(aPath);

  if (activeCat=== undefined)
    return;

  let rect = activeCat.getBoundingClientRect();
  let posactive = rect.x+rect.width;
  let parent = activeCat.parentElement;
  if ( parent.nodeName == "LI")
    parent = parent.parentElement;

  let rectNav = parent.getBoundingClientRect();

  let widthNav= rectNav.x+rectNav.width;
  if ( rect.x < 0 ){
    parent.scrollLeft = parent.scrollLeft  + rect.x;
  }
  if (posactive > widthNav) {
    let offset = posactive-widthNav;
    parent.scrollLeft = parent.scrollLeft + offset;
  }

}


// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
const scrollBehavior = function (to) {

  /*if (savedPosition) {
    console.log(savedPosition);
    // savedPosition is only available for popstate navigations.
    return savedPosition
  } else {*/
  const position = {}

  // scroll to anchor by returning the selector
  if (to.params.page) {

    scrollToCategory("#navbar-list li [href='#"+to.params.page+"']");

    position.selector = '#' + to.params.page;
    //console.log(position);

    // specify offset of the element
    if (to.hash === '#anchor2') {
      position.offset = { y: 100 }
    }

    if (document.querySelector('#' + to.params.page)) {
      //console.log('gefunden');
      return position
    }

    // if the returned position is falsy or an empty object,
    // will retain current scroll position.
    return false
  }
  else if (to.params.category) {
    position.x = 0;
    position.y = 0;
    scrollToCategory("#navbarCategories .active");
    return position;
  }

  return new Promise(resolve => {
    // check if any matched route config has meta that requires scrolling to top
    if (to.matched.some(m => m.meta.scrollToTop)) {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      position.x = 0
      position.y = 0
    }
    // wait for the out transition to complete (if necessary)
    this.app.$root.$once('triggerScroll', () => {
      // if the resolved position is falsy or an empty object,
      // will retain current scroll position.
      resolve(position)
    })
  })
  /*}*/
}

export default new Router({
  scrollBehavior,
  routes: [
    {
      path: '/',
      redirect: 'static/news',
      name: 'home'
    },
    {
      path: '/static',
      redirect: 'static/news',
    },
    {
      path: '/static/:category',
      name: 'static',
      component: Home
    },
    {
      path: '/static/:category/:page',
      name: 'staticWithPage',
      component: Home
    },
    {
      path: '/user',
      redirect: 'user/news',
      name: 'userhome'
    },
    {
      path: '/user/:category',
      name: 'user',
      component: User
    },
    {
      path: '/user/:category/:page',
      name: 'userWithPage',
      component: User
    },
    {
      path: '/provider/:mode',
      name: 'provider',
      component: Provider
    },
    {
      path: '/test',
      name: 'test',
      component: Test
    },
    {
      path: '/search',
      name: 'search',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/impressum',
      name: 'impressum',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Impressum.vue')
    },
    {
      path: '/dsvgo',
      name: 'dsvgo',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Dsvgo.vue')
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  linkActiveClass: "active",
})
